export default function About() {
  return (
    <section id="about" className="bg-[#F8F9FA] py-32">
      <div className="max-w-7xl mx-auto px-8 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
          <div className="lg:col-span-2">
            <p className="text-xs font-semibold text-gray-500 tracking-widest uppercase mb-4">
              ABOUT FLUXPOINT
            </p>
            <h2 className="text-4xl font-bold text-[#1A2B4A] mb-6">
              Integrated Digital Operations
            </h2>
            <div className="w-11/12">
              <p className="text-base text-gray-600 leading-relaxed mb-4">
                FluxPoint Digital LLC is a hybrid digital investment and operations group focused on scalable infrastructure, disciplined capital allocation, and llong-term asset growth.
              </p>
              <p className="text-base text-gray-600 leading-relaxed mb-4">
                We develop and operate digital platforms, manage media properties, and allocate capital into diversified holdings including cryptocurrency and rental real estate.
              </p>
              <p className="text-base text-gray-600 leading-relaxed">
                Our model integrates operational execution with strategic investment to create durable, compounding value.
              </p>
            </div>
          </div>

          <div className="lg:col-span-3 flex justify-center lg:justify-end">
            <div className="w-full max-w-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/4cd44837c648ff6cb6735ec64a9f4ee7.jpg"
                alt="FluxPoint Digital Operations"
                className="w-full h-auto rounded-3xl shadow-lg object-cover"
                style={{ aspectRatio: '4/3' }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-8 lg:px-16 mt-8">
        <div className="h-px bg-gray-300"></div>
      </div>
    </section>
  );
}